import { render, staticRenderFns } from "./CustomScoringParsingSettings.vue?vue&type=template&id=ac0fa9ce"
import script from "./CustomScoringParsingSettings.vue?vue&type=script&lang=js"
export * from "./CustomScoringParsingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports